import React from "react";
import Tooltip from "@mui/material/Tooltip";

interface IconWithTooltipProps {
  componentName: string;
  tooltipText: string;
  IconComponent: React.ElementType;
  onClick?: () => void;
  disabledContent?: boolean;
}

export const IconWithTooltip = ({
  componentName,
  tooltipText,
  IconComponent,
  onClick,
  disabledContent,
}: IconWithTooltipProps) => {
  const disabledText = `You need to upgrade your account to ${tooltipText.toLowerCase()}`;

  return (
    <Tooltip
      data-testid={`${componentName}-icon-tooltip`}
      title={!disabledContent ? tooltipText : disabledText}
    >
      <span style={{ display: "inline-block" }}>
        <IconComponent
          data-testid={`${componentName}-icon`}
          onClick={!disabledContent ? onClick : undefined}
          sx={{
            cursor: disabledContent ? "not-allowed" : "pointer",
            opacity: disabledContent ? 0.5 : 1,
            pointerEvents: disabledContent ? "none" : "auto",
          }}
        />
      </span>
    </Tooltip>
  );
};
